function videoInit() {
    const videoEvent = 'ontouchstart' in window ? 'touchstart' : 'mousemove';
    const videoItems = document.querySelectorAll('.js-a-video__video-tag');

    videoItems.forEach((videoItem) => {
        if (videoItem.hasAttribute('autoplay')) {
            return;
        }

        window.addEventListener(
            videoEvent,
            () => {
                const sizes = videoItem.getBoundingClientRect();

                // if is visible
                if (sizes.width > 0) {
                    videoItem.play();
                }
            },
            {
                once: true,
            },
        );
    });
}

export default videoInit;
